import { memo } from 'react';

import { Flex, Typography } from 'antd';

import EmptyPlaceholder from '../../ui-components/EmptyPlaceholder';

import styles from './styles.module.scss';

const { Title, Text } = Typography;

function CountersList({ data, color }) {
  return (
    <>
      {data?.length > 0 ? (
        <Flex className="w-full" vertical={true} gap="small">
          {data?.map(item => (
            <Flex key={item.title} className="w-full" vertical={false} gap="small" justify="space-between">
              <span className={styles.badge}>{item.title}</span>
              {isNaN(item.value) ? (
                <Text type="secondary">{item.value ?? '/'}</Text>
              ) : (
                <Title level={5} style={{ color }}>
                  {item.value}
                </Title>
              )}
            </Flex>
          ))}
        </Flex>
      ) : (
        <EmptyPlaceholder />
      )}
    </>
  );
}

export default memo(CountersList);
